import { SimpleGrid } from "@chakra-ui/layout";
import { Skeleton } from "antd";
import { CobrancaDetails } from "features/cobranca/typings";
import ConteudoDadosContato from "./ConteudoDadosContato";

interface DadosDeContatoProps {
  dataCobranca: CobrancaDetails;
}

function DadosDeContato({ dataCobranca }: DadosDeContatoProps) {
  if (!dataCobranca) {
    return <Skeleton active />;
  }

  return (
    <>
      <SimpleGrid gap={6} columns={1}>
        {dataCobranca.proprietario ? (
          <ConteudoDadosContato
            pessoa={dataCobranca.proprietario}
            title={"Proprietário"}
          />
        ) : null}

        {dataCobranca.locatario ? (
          <ConteudoDadosContato
            pessoa={dataCobranca.locatario}
            title={"Locatário"}
          />
        ) : null}
      </SimpleGrid>
    </>
  );
}

export default DadosDeContato;
